<template>
  <div class="block">
    <el-tag>选择账户： </el-tag>
    <div class="block">
      <el-cascader
        v-model="userUalue"
        :options="options1"
        filterable></el-cascader>
    </div>
    <el-divider direction="vertical"></el-divider>
    <el-tag>选择汇总方式：</el-tag>
    <el-select v-model="value" placeholder="请选择">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-divider direction="vertical"></el-divider>

    <el-tag>选择层级：</el-tag>
    <el-select v-model="values" placeholder="请选择">
      <el-option
        v-for="items in level"
        :key="items.value"
        :label="items.label"
        :value="items.value">
      </el-option>
    </el-select>
    <el-divider direction="vertical"></el-divider>

    <el-tag>输入起止日期：</el-tag>
    <el-date-picker
      v-model="value1"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyyMMdd"
      :picker-options="pickerOptions"
      @change="chooseTimeRange">
    </el-date-picker>
    <el-button type="primary" v-on:click="exportExcel" round>导出</el-button>
    <el-button type="primary" v-on:click="getDataList" :disabled="isDisable" round>查询</el-button>
    <el-divider></el-divider>

    <el-table
      stripe
      :default-sort = "{prop: 'date', order: 'descending'}"
      :data="datas"
      id="exportTab"
      :summary-method="getSummaries"
      show-summary
      style="width: 100%">
      <el-table-column
        sortable
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="campaignName"
        label="计划名称"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupId"
        label="广告组ID"
        width="100">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupName"
        label="广告组名称"
        width="200">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementId"
        width="120"
        label="广告ID">
      </el-table-column>
      <el-table-column
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementName"
        label="广告名称"
        width="300">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        prop="creativeId"
        label="创意ID">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="placeType"
        label="广告位类型">
      </el-table-column>
      <el-table-column
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="cvType"
        label="转化类型">
      </el-table-column>
      <el-table-column
        prop="reportDate"
        width="120"
        label="按天维度查询时返回">
      </el-table-column>
      <el-table-column
        sortable
        prop="name"
        width="120"
        label="名称">
      </el-table-column>
      <el-table-column
        prop="reportTime"
        width="140"
        label="时间">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        prop="balance"
        width="180"
        label="现金余额">
      </el-table-column>
      <el-table-column
        sortable
        prop="showCount"
        label="曝光量"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="clickCount"
        label="点击量">
      </el-table-column>
      <el-table-column
        prop="CTR"
        :formatter="ChangeToPercentage"
        label="点击率">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        width="150"
        prop="spent"
        label="花费">
      </el-table-column>
      <el-table-column
        sortable
        prop="formsubmitCount"
        label="表单提交量">
      </el-table-column>
      <el-table-column
        sortable
        prop="but"
        label="表单成本"
      >
      </el-table-column>
      <el-table-column
        prop="customPayC"
        label="自定义付费数(按计费时间)">
      </el-table-column>
      <el-table-column
        prop="zdyff"
        label="自定义付费数成本">
      </el-table-column>
      <el-table-column
        prop="reactivation"
        label="自定义拉活数(按计费时间)">
      </el-table-column>
      <el-table-column
        prop="zdylh"
        label="自定义拉活数成本">
      </el-table-column>
      <el-table-column
        prop="customRetainCount"
        label="自定义次留">
      </el-table-column>
      <el-table-column
        prop="zdycl"
        label="自定义次留成本">
      </el-table-column>

      <el-table-column
        sortable
        prop="CVR"
        :formatter="ChangeToPercentage"
        label="转化率">
      </el-table-column>
      sortable
      <el-table-column
        prop="CLR"
        :formatter="ChangeToPercentage"
        label="次留率">
      </el-table-column>
    </el-table>
  </div>

</template>

<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {


  data() {
    return {
      isDisable:false,
      userUalue:'',
      options1: [
        {
          value: 'sl',
          label: '盛霖',
          children: [{
            value: 'nbzy',
            label: '宁波种牙',
          },
            {
              value: 'xmzy',
              label: '厦门种牙',
            },   {
              value: 'czdjf',
              label: '财咨道加粉',
            },   {
              value: 'czdbd',
              label: '财咨道表单',
            },{
              value: 'zjxd',
              label: '浙江享点',
            },

          ]
        },
      ],
      options: [{
        value: 'DAY',
        label: '按天汇总'
      }, {
        value: 'HOUR',
        label: '按小时汇总'
      }, {
        value: 'SUMMARY',
        label: '汇总'
      }
      ],
      value: '',
      level: [{
        value: 'ACCOUNT',
        label: '账户层级'
      }, {
        value: 'CAMPAIGN',
        label: '计划层级'
      }, {
        value: 'GROUP',
        label: '广告组层级'
      },
        {
          value: 'ADVERTISEMENT',
          label: '广告层级'
        },
        {
          value: 'CREATIVE',
          label: '创意层级'
        }],
      /*
      小邱
       */
      sl:['f7b0285e54512a4e26b6c2ae9710fab2672090b7b588448ba2fff815a55b8a97','6e14bf7663fb6c736e7b3468009ba242cb434ca25ce38533cd4570406ed8982e','74867f90966baae7d6717a4d96e65b7cbde2b7007516393505f21395afae238b'],
      xmzy:['cbdb5f7965c3f30b9818','3ca18d3bd823616a27b7','5afc10d03ef58765bef7'],
      nbzy:['0d608a8173f4c4204aa6','e4761fe4ef3a7ab61fdd','51b284ddba2b283f6d68','1b941f5e5f11c87185f8','7e47b3e6217cbb7c972f','18ae1b047bd2a39acdca'],
      //数据
      czdjf:['974b2af9ce82fb9054c1','603f8017582c594264fa','23eecc162155e27b0c98','ed1f62e5df2cc67e84c1','885795bb61ac63a051bc',
        'b17c0a785621b17b9313','cc5d511d0827bec25998','e08b52f4beaffd5b90ce','c1f1516e55779ab72b34','6e4ec6a2bc0566a7304d'],
      czdbd:['7bebfe9ecaafe9147655','5c2afa83758d1c638226','f4e9229611e43ff80e47','d8095a5f2e1ee264b278','dbcca21f25521713c4d6'],
      zjxd:['65d0d3e224b86ed332a7','0ade7cd35bdeb3358b3d','2d63dbc81dba72ed6e7b','12ee3ce6298b9d17e777','1b989601080cb8fa5675'],
      values: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      time:'',
      value1: '',
      value2: '',
      datas:[],
      datadata:[],
      temp:[],
      temp1:[],
      temp2:[],
      startDate:'20220701',
      endDate:'20220710',
      namedata:[],
      datanums:[
        {
          nuMshowCount:0,
          nuMclickCount:0,
          nuMspent:0,
          nuMformsubmitCount:0,
          nuMdisGeneralBalance:0,
          nuMbalance:0,
          nuMcustomPayCount:0,
          nuMreactivation:0,
          nuMcustomRetainCount:0
        }
      ],
      ctrJson:[{
        CTR:0,
        CVR:0,
        CLR:0,
        but:0,
        zdycl:0,
        zdyff:0,
        zdylh:0

      }],



    }
  },

  methods:{
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总汇';
          return;
        }
        if (index === 9) {
          sums[index] = sums[index-2]/sums[index-1];
          sums[index] =  sums[index].toFixed(2) ;
          return;

        }
        if (index === 6) {
          sums[index] = sums[index-1]/sums[index-2];
          sums[index]=sums[index]*100
          sums[index]=sums[index].toFixed(2);
          sums[index]= sums[index]+'%'
          return;

        }
        if (index === 11) {
          sums[index] = sums[index-4]/sums[index-1];
          sums[index]=sums[index].toFixed(4);
          sums[index]=sums[index]
          return;

        }
        if (index === 13) {
          sums[index] = sums[index-6]/sums[index-1];
          sums[index]=sums[index].toFixed(4);
          sums[index]=sums[index]
          return;

        }
        if (index === 15) {
          sums[index] = sums[index-8]/sums[index-1];
          sums[index]=sums[index].toFixed(4);
          sums[index]=sums[index]
          return;

        }
        if (index === 16) {
          sums[index] = sums[index-8]/sums[index-11];
          sums[index]=sums[index].toFixed(4);
          sums[index]=sums[index]*100+'%'
          return;

        }
        if (index === 17) {
          sums[index] = sums[index-5]/sums[index-9];
          sums[index]=sums[index].toFixed(4);
          sums[index]=sums[index]*100+'%'
          return;

        }


        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value)) ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);

          sums[index] = sums[index].toFixed(2) + "";
        } else {
          sums[index] = '';
        }
      });

      return sums;
    }
    ,
    exportExcel () {
      /* generate workbook object from table */
      var xlsxParam = { raw: false } // 导出的内容只做解析，不进行格式转换
      var wb = XLSX.utils.table_to_book(document.querySelector('#exportTab'), xlsxParam)
      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '数据导出.xlsx')
      } catch (e) {
        if (typeof console !== 'undefined') {
          console.log(e, wbout)
        }
      }
      return wbout
    },
    rule(row,column){
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property]).toFixed(2)
        return percent
      }
    },
    ChangeToPercentage: function(row, column) {
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property] * 100).toFixed(2) + '%'
        return percent
      }

    },

    // 获取时间戳，获取时间选择器时间
    chooseTimeRange(value1){
      this.time = parseInt(new Date().getTime()) + '';
      console.log(this.time)
      this.value2=value1;

    },
    getDataList() {
      this.time = parseInt(new Date().getTime()) + '';
      this.datanums[0].nuMshowCount=0
      this.datanums[0].nuMclickCount=0
      this.datanums[0].nuMspent=0
      this.datanums[0].nuMformsubmitCount=0
      this.datanums[0].nuMbalance=0
      this.datanums[0].nuMdisGeneralBalance=0
      this.datanums[0].nuMcustomPayCount=0
      this.datanums[0].nuMreactivation=0
      this.datanums[0].nuMcustomRetainCount=0
      this.datas=null
      this.datadata=[]
      this.namedata=[]
      this.temp2=[]
      this.temp1=[]
      this.temp=[]
      console.log(this.userUalue[0])
      console.log(this.userUalue[1])
      if(this.userUalue[0]==="sl"){
        this.isDisable = true
        this.TimeChangeto1();
      }

    },


    hb(jsonbject1, jsonbject2) {
      var resultJsonObject = {};
      for (var attr in jsonbject1) {
        resultJsonObject[attr] = jsonbject1[attr];
      }
      for (var attr in jsonbject2) {
        resultJsonObject[attr] = jsonbject2[attr];
      }
      return resultJsonObject;
    },

    async TimeChangeto1 () {
      console.log("看到我了")
      console.log(this.userUalue[1])
      if (this.userUalue[1]==="nbzy"){
        console.log("2")
        for (let a = 0; a < this.nbzy.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.sl[0] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.nbzy[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            if (resp.data.data.items != null) {
              // 追加数据
              if (this.value==="HOUR"){
                console.log(resp.data.data.items)
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }
              this.$message.success("正在查询第" + a + "条数据")

              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.sl[0] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.nbzy[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)

                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }
        //渲染页
        setTimeout(() => {
          this.temp = JSON.parse(JSON.stringify(this.datadata))
          this.temp1 = JSON.parse(JSON.stringify(this.namedata))
          for (let key = 0; key < this.temp.length; key++) {
            this.temp1[key].balance = this.temp1[key].balance / 100000
            this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
            this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
            let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
            this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
            this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

            this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])
          }

          this.datas = this.temp2
          this.isDisable = false
        }, 4000)


      }
      if (this.userUalue[1]==="xmzy"){

        for (let a = 0; a < this.xmzy.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.sl[0] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.xmzy[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            if (resp.data.data.items != null) {
              // 追加数据
              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }               this.$message.success("正在查询第" + a + "条数据")

              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.sl[0] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.xmzy[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)

                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }

        //渲染页面

        setTimeout(() => {
          this.temp = JSON.parse(JSON.stringify(this.datadata))
          this.temp1 = JSON.parse(JSON.stringify(this.namedata))
          for (let key = 0; key < this.temp.length; key++) {
            this.temp1[key].balance = this.temp1[key].balance / 100000
            this.temp2[key] = this.hb(this.temp1[key], this.temp[key])


            this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);

            let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);

            this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);

            this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount

            // 截取当前数据到小数点后两位 （四舍五入）
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            // 先截取当前数据到小数点后三位 （不会四舍五入）
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            // 再取该数值长度-1的内容
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

            this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])

          }

          this.datas = this.temp2
          this.isDisable = false
        }, 4000)


      }
      if (this.userUalue[1]==="czdjf"){
        console.log("2")
        for (let a = 0; a < this.czdjf.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.sl[1] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.czdjf[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            if (resp.data.data.items != null) {
              // 追加数据
              if (this.value==="HOUR"){
                for (let b=0;b<resp.data.data.items.length;b++){
                      this.datadata.push(resp.data.data.items[b])
                }
              }else {
                this.datadata.push(resp.data.data.items[0])
              }
              this.$message.success("正在查询第" + a + "条数据")

              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.sl[1] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.czdjf[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      for(let e=0;e<resp.data.data.items.length;e++){
                        this.namedata.push(res.data.data)

                      }

                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }
        //渲染页
        setTimeout(() => {
          this.temp = JSON.parse(JSON.stringify(this.datadata))
          this.temp1 = JSON.parse(JSON.stringify(this.namedata))
          for (let key = 0; key < this.temp.length; key++) {
            this.temp1[key].balance = this.temp1[key].balance / 100000
            this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
            this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
            let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
            this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
            this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

            this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])
          }

          this.datas = this.temp2
          this.isDisable = false
        }, 4000)


      }
      if (this.userUalue[1]==="czdbd"){
        console.log("2")
        for (let a = 0; a < this.czdbd.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.sl[1] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.czdbd[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            if (resp.data.data.items != null) {
              // 追加数据
              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }
              this.$message.success("正在查询第" + a + "条数据")

              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.sl[1] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.czdbd[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)

                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }
        //渲染页
        setTimeout(() => {
          this.temp = JSON.parse(JSON.stringify(this.datadata))
          this.temp1 = JSON.parse(JSON.stringify(this.namedata))
          for (let key = 0; key < this.temp.length; key++) {
            this.temp1[key].balance = this.temp1[key].balance / 100000
            this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
            this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
            let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
            this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
            this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

            this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])
          }

          this.datas = this.temp2
          this.isDisable = false
        }, 4000)


      }
      if (this.userUalue[1]==="zjxd"){
        console.log("2")
        for (let a = 0; a < this.zjxd.length; a++) {
          let nonce1 = Math.round(Math.random() * 1000000000000000)
          let nonce = Math.round(Math.random() * 100000000000)
          await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + this.sl[2] + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + this.zjxd[a], {
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            pageIndex: "1",
            pageSize: "100",
            summaryType: this.value,
            level: this.values
          }).then(async resp => {
            if (resp.data.data.items != null) {
              // 追加数据
              if (this.value==="HOUR"){
                this.datadata.push(resp.data.data.items[resp.data.data.items.length-1])
              }else {
                this.datadata.push(resp.data.data.items[0])
              }
              this.$message.success("正在查询第" + a + "条数据")

              await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + this.sl[2] + '&timestamp=' + this.time + '&nonce=' + nonce1 + '&advertiser_id=' + this.zjxd[a])
                .then(res => {
                    if (res.data.message == '请求成功') {
                      this.namedata.push(res.data.data)

                    } else {
                      console.log(res.data.message)
                    }
                  }
                )
            }
          })

        }
        //渲染页
        setTimeout(() => {
          this.temp = JSON.parse(JSON.stringify(this.datadata))
          this.temp1 = JSON.parse(JSON.stringify(this.namedata))
          for (let key = 0; key < this.temp.length; key++) {
            this.temp1[key].balance = this.temp1[key].balance / 100000
            this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
            this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
            this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
            let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
            this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
            this.ctrJson[0].CTR = this.temp2[key].clickCount / this.temp2[key].showCount
            this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
            let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
            this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
            this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount
            this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
            let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
            this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
            this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount
            this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
            let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
            this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

            this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
            this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
            let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
            this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);

            this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
            this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
            let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
            this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);


            this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
            this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
            let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
            this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

            this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])
          }

          this.datas = this.temp2
          this.isDisable = false
        }, 4000)


      }
    },


  },
  created () {  },
}
</script>



// WEBPACK FOOTER //
// src/components/time.vue